export const DIRECTIONS_MAX_LENGTH = 300;
export const CUSTOM_COLUMN_MAX_LENGTH = 150;
export const CUSTOM_COLUMN_INT_MIN = -999999999;
export const CUSTOM_COLUMN_INT_MAX = 999999999;
